/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-10 20:01:31
 */

import StationList from '../stationList';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import StationListApi, { StationListDOI } from '../api/stationListApi';
import _ from 'lodash';
import override from 'src/dectorators/override';
import ListPageService from 'src/types/ListPage';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import Input from 'src/types/iview/Input';
import EnumControlLevel from 'src/enums/enumControlLevel';
import EnmuCommunicationStatus from 'src/enums/enmuCommunicationStatus';
import EnumStationType from 'src/enums/enumStationType';
import AreaCascader from 'src/components/areaCascader/areaCascader';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import RouteUtils from 'src/util/routeUtils';
import { createBEM } from 'src/util/bem';
import EnumDeviceStatus from 'src/enums/enumDeviceStatus';
import EnumSiteStatus from 'src/enums/enumSiteStatus';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import {DateTimeUtil} from 'src/util/dateTimeUtil';
let bem = createBEM('station-list');
export default class StationListService extends ListPageService {
    ctx: StationList;

    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

    constructor(ctx: StationList) {
        super();
        this.ctx = ctx;
    }

    static goToStationDetail(type, data: StationListDOI.RowDataI, tag: string = '') {
        RouteUtils.goToWidthCache(`/${EnumStationType.findId(type).getCode()}/detection/station/detail`, { mn: data.mn + '', productId: data.product_id, id: data.id, factorset: data.factorset, type:type, tag })
    }

    @override
    createColumns(): ColDefCustom[] {
        //2  8
        let t = this;
        return [
            {
                headerName: '站点名称',
                field: 'name',
                minWidth: 180,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span class="wqms-cursor wqms-link" style="color:red"
                                    on-click={() => {
                                        StationListService.goToStationDetail(t.type, data)
                                    }}
                                >
                                    {data.name}
                                </span>
                            );
                        } else if (data.site_status == 2) {
                            return (
                                <span class="wqms-cursor wqms-link" style="color: #fe940b"
                                    on-click={() => {
                                        StationListService.goToStationDetail(t.type, data)
                                    }}
                                >
                                    {data.name}
                                </span>
                            );
                        } else {
                            return (
                                <div
                                    class="wqms-cursor wqms-link"
                                    on-click={() => {
                                        StationListService.goToStationDetail(t.type, data)
                                    }}
                                >
                                    {data.name}
                                </div>
                            );
                        }
                    },
                },
            },
            this.type === EnumStationType.Pollution.getId() ? {
                headerName: '排放口名称',
                field: 'section',
                minWidth: 120,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span style="color:red"
                                >
                                    {data.section}
                                </span>
                            );
                        }else if(data.site_status == 2){
                            return (
                                <span style="color:#fe940b"
                                >
                                    {data.section}
                                </span>
                            );
                        } else {
                            return (
                                data.section
                            );
                        }
                    },
                },
            } : {
                    headerName: '断面类型',
                    field: 'section',
                    minWidth: 120,
                    cellRendererFramework: CellRenderTsx,
                    cellRendererFrameworkOpt: {
                        cellRender(h, params) {
                            let data: StationListDOI.RowDataI = params.data;
                            if (data.site_status == 0) {
                                return (
                                    <span style="color:red"
                                    >
                                        {data.section}
                                    </span>
                                );
                            }else if(data.site_status == 2){
                                return (
                                    <span style="color:#fe940b"
                                    >
                                        {data.section}
                                    </span>
                                );
                            } else {
                                return (
                                    data.section
                                );
                            }
                        },
                    },
                },
            {
                headerName: '区域',
                field: 'idNumber',
                minWidth: 190,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span style="color:red"
                                >
                                    {data.province_name + data.city_name + data.district_name}
                                </span>
                            );
                        }else if(data.site_status == 2){
                            return (
                                <span style="color:#fe940b"
                                >
                                    {data.province_name + data.city_name + data.district_name}
                                </span>
                            );
                        } else {
                            return (
                                data.province_name + data.city_name + data.district_name
                            );
                        }
                    },
                },
            }, {
                headerName: '流域',
                field: 'basin',
                minWidth: 100,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span style="color:red"
                                >
                                    {data.basin}
                                </span>
                            );
                        }else if(data.site_status == 2){
                            return (
                                <span style="color:#fe940b"
                                >
                                    {data.basin}
                                </span>
                            );
                        } else {
                            return (
                                data.basin
                            );
                        }
                    },
                },
            },
            {
                headerName: '通讯状态',
                field: 'device_status',
                minWidth: 80,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        return (
                            <img src={data.device_status === EnmuCommunicationStatus.Online.getId() ? require('../../../assets/images/WIFI-01.png') : require('../../../assets/images/wifi-02.png')}></img>
                            // <div
                            //     class={bem('communication-status', {
                            //         online: data.device_status === EnmuCommunicationStatus.Online.getId(),
                            //         offline: data.device_status === EnmuCommunicationStatus.OffLine.getId(),
                            //     })}
                            // />
                        );
                    },
                },
            },
            {
                headerName: '站点状态',
                field: 'site_status',
                minWidth: 80,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span style="color:red"
                                >
                                    {EnumSiteStatus.findId(data.site_status).getName()}
                                </span>
                            );
                        }else if(data.site_status == 2){
                            return (
                                <span style="color:#fe940b"
                                >
                                {EnumSiteStatus.findId(data.site_status).getName()}
                                </span>
                            );
                        } else {
                            return (
                                EnumSiteStatus.findId(data.site_status).getName()
                            );
                        }
                    },
                },
            },
            {
                headerName: '控制级别',
                field: 'control_hierarchy',
                minWidth: 80,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span style="color:red"
                                >
                                    {EnumControlLevel.findId(data.control_hierarchy).getName()}
                                </span>
                            );
                        }else if(data.site_status == 2){
                            return (
                                <span style="color:#fe940b"
                                >
                                {EnumControlLevel.findId(data.control_hierarchy).getName()}
                                </span>
                            );
                        } else {
                            return (
                                EnumControlLevel.findId(data.control_hierarchy).getName()
                            );
                        }
                    },
                },
            },
            {
                headerName: '最后数据时间',
                field: 'data_time',
                minWidth: 170,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: StationListDOI.RowDataI = params.data;
                        if (data.site_status == 0) {
                            return (
                                <span style="color:red"
                                >
                                    {DateTimeUtil.formateDate(data.data_time)}
                                </span>
                            );
                        }else if(data.site_status == 2){
                            return (
                                <span style="color:#fe940b"
                                >
                                {DateTimeUtil.formateDate(data.data_time)}
                                </span>
                            );
                        } else {
                            return (
                                DateTimeUtil.formateDate(data.data_time)
                            );
                        }
                    },
                },
            },
        ];
    }



    @override
    createBtnGroup(): Array<IconBtnItem> {
        //3
        return [];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: AreaCascader,
                label: '区域',
                field: 'area：',
                width: 280,
                labelWidth: 40,
                dealParam(value) {
                    return {
                        province_id: value[0],
                        city_id: value[1],
                        district_id: value[2],
                    };
                },
                props: { value: [], type: this.type },
            },
            {
                component: EntitySelect,
                label: '所属流域',
                field: 'basin',
                labelWidth: 60,
                width: 160,
                props: { value: null, type: EnumEntity.Basin.getId() },
            },
            {
                component: CommonSelect,
                label: '控制级别',
                width: 160,
                labelWidth: 60,
                field: 'control_hierarchy',
                props: { value: null, dataSource: EnumControlLevel.getList() },
            },
            {
                component: CommonSelect,
                label: '通讯状态',
                width: 160,
                labelWidth: 60,
                field: 'communication_status',
                props: { value: null, dataSource: EnmuCommunicationStatus.getList() },
            },
            {
                component: CommonSelect,
                label: '站点状态',
                width: 160,
                labelWidth: 60,
                field: 'site_status',
                props: { value: null, dataSource: EnumSiteStatus.getList() },
            },
            {
                component: Input,
                label: '',
                labelWidth: 20,
                width: 150,
                field: 'device_name',
                props: { value: '', placeholder: '请输入站点名称' },
            },
        ];
    }

    @override
    initSearchParams(): void {
        //4  //6
        this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<StationListDOI.QueryRowDataParamsI>(),
            type: this.type,
        };
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        //7
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await StationListApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.columnDefs = [
                ...this.createColumns(),
                ...data.header.map(i => ({
                    headerName: `${i.name}(${i.unit})`,
                    field: i.key,
                    minWidth: 100,
                    cellRendererFramework: CellRenderTsx,
                    cellRendererFrameworkOpt: {
                        cellRender: function (h, params) {
                            let data: StationListDOI.RowDataI = params.data;
                            var keys = i.key + "-Flag"
                            if (data[keys] == "T") {
                                return (
                                    <span style="color:red"
                                    >
                                        {data[i.key]}
                                    </span>
                                );
                            }else if(data.site_status == 2){
                                return (
                                    <span style="color:#fe940b"
                                    >
                                    {data[i.key]}
                                    </span>
                                );
                            } else {
                                return (
                                    data[i.key]
                                );
                            }
                        },
                    },
                })),
            ];
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
